import React from 'react';
import { TrendingUp } from 'lucide-react';
import { useScopeRiskSummary } from '../../../hooks/analytics/useScopeReports.ts';
import { StatCard, WidgetCard } from '../controller/shared.tsx';

/** `scope_risk_delta` — period-over-period Δ in total risks in scope. */
export const ScopeRiskDeltaCard: React.FC = () => {
  const { data, isLoading, isError, error, dataUpdatedAt, isFetching, refetch } = useScopeRiskSummary();

  return (
    <WidgetCard
      title="Risk Count Δ"
      loading={isLoading}
      error={isError ? error : null}
      errorMessage={error?.message ?? 'Failed to load risk count delta.'}
      isEmpty={!isLoading && !isError && !data}
      updatedAt={dataUpdatedAt}
      onRefresh={refetch}
      isFetching={isFetching}
    >
      <StatCard
        title="Risk Count vs. Prior Sweep"
        value={data?.total ?? 0}
        icon={<TrendingUp className="h-5 w-5" />}
        color="bg-rose-100 text-rose-600"
        delta={data?.delta ?? undefined}
        deltaSuffix=""
        deltaDigits={0}
        subtitle={data?.prev_total != null ? `was ${data.prev_total}` : 'no prior snapshot'}
      />
    </WidgetCard>
  );
};

export default ScopeRiskDeltaCard;
